export function groupLogsByProcessInstanceId(logs) {
  let group = makeReverseKeys(logs.slice())

  logs.forEach(function(x) {
    let key = getLogPIID(x)
    group[key].push(x)
  })

  return group
}

function makeReverseKeys(logs) {
  let group = {}
  logs.reverse().forEach(function(x) {
    let key = getLogPIID(x)

    if (!group[key]) {
      group[key] = []
    }
  })

  return group
}

function getLogPIID(log) {
  return log._source['ProcessInstanceId']
}